module.exports = __webpack_public_path__ + "static/media/phone-icon.3678fb7f.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/phone-icon.svg
// module id = 1839
// module chunks = 0